export const ON_OFF_TYPES = {
    ON: 'ON',
    OFF: 'OFF',
};

export const getBoolValueByOnOffType = (onOffType) => onOffType === ON_OFF_TYPES.ON;
export const getOnOffTypeByValue = (bool) => (bool ? ON_OFF_TYPES.ON : ON_OFF_TYPES.OFF);
